import { createTheme } from "@mui/material";

// Ét tema for hele admin-panelet, så sider, tabeller og knapper ser ens ud.
// Farverne er Breefers egne (orange fra logoet). Se local-dev/DESIGN-SPEC.md.
export const BRAND = {
  orange: "#EB6608",
  orangeDark: "#c75405",
  ink: "#1f2430",
  muted: "#5b6472",
  line: "#e3e6ea",
  surface: "#ffffff",
  background: "#f5f6f8",
  ok: "#2e7d32",
  warn: "#ed6c02",
  error: "#c62828",
};

const theme = createTheme({
  palette: {
    primary: { main: BRAND.orange, dark: BRAND.orangeDark, contrastText: "#fff" },
    success: { main: BRAND.ok },
    warning: { main: BRAND.warn },
    error: { main: BRAND.error },
    background: { default: BRAND.background, paper: BRAND.surface },
    text: { primary: BRAND.ink, secondary: BRAND.muted },
    divider: BRAND.line,
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    h1: { fontSize: "1.75rem", fontWeight: 600 },
    h2: { fontSize: "1.4rem", fontWeight: 600 },
    h3: { fontSize: "1.15rem", fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 8 } },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
        outlined: { borderColor: BRAND.line },
      },
    },
    // Tabeller: rolig lys række med ramme i stedet for et tungt orange bånd
    MuiTableHead: {
      styleOverrides: { root: { backgroundColor: "#f0f1f4" } },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: BRAND.line },
        head: { color: BRAND.ink, fontWeight: 600, whiteSpace: "nowrap", backgroundColor: "#f0f1f4" },
      },
    },
    MuiTableRow: {
      styleOverrides: { root: { "&:last-child td": { borderBottom: 0 } } },
    },
    MuiTextField: { defaultProps: { size: "small" } },
    // Låste felter (vis-tilstand) skal stadig kunne læses
    MuiInputBase: {
      styleOverrides: { input: { "&.Mui-disabled": { WebkitTextFillColor: "rgba(31,36,48,0.85)" } } },
    },
    MuiInputLabel: { styleOverrides: { root: { "&.Mui-disabled": { color: "rgba(91,100,114,0.9)" } } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 500 } } },
    MuiTooltip: { defaultProps: { arrow: true } },
  },
});

export default theme;
